/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heading_Reads_HighlightInputs */

const en_heading_reads_highlight = /** @type {(inputs: Heading_Reads_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reads`)
};

const ar_heading_reads_highlight = /** @type {(inputs: Heading_Reads_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مشابهة`)
};

const bn_heading_reads_highlight = /** @type {(inputs: Heading_Reads_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লেখা`)
};

const de_heading_reads_highlight = /** @type {(inputs: Heading_Reads_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texte`)
};

const es_heading_reads_highlight = /** @type {(inputs: Heading_Reads_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`similares`)
};

const fr_heading_reads_highlight = /** @type {(inputs: Heading_Reads_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`liées`)
};

const pt_heading_reads_highlight = /** @type {(inputs: Heading_Reads_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`semelhantes`)
};

const zh_heading_reads_highlight = /** @type {(inputs: Heading_Reads_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`读取`)
};

const tr_heading_reads_highlight = /** @type {(inputs: Heading_Reads_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okumalar`)
};

const ru_heading_reads_highlight = /** @type {(inputs: Heading_Reads_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`читает`)
};

const pl_heading_reads_highlight = /** @type {(inputs: Heading_Reads_HighlightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czyta`)
};

/**
* | output |
* | --- |
* | "Reads" |
*
* @param {Heading_Reads_HighlightInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const heading_reads_highlight = /** @type {((inputs?: Heading_Reads_HighlightInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heading_Reads_HighlightInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_heading_reads_highlight(inputs)
	if (locale === "bn") return bn_heading_reads_highlight(inputs)
	if (locale === "de") return de_heading_reads_highlight(inputs)
	if (locale === "es") return es_heading_reads_highlight(inputs)
	if (locale === "fr") return fr_heading_reads_highlight(inputs)
	if (locale === "pt") return pt_heading_reads_highlight(inputs)
	if (locale === "zh") return zh_heading_reads_highlight(inputs)
	if (locale === "tr") return tr_heading_reads_highlight(inputs)
	if (locale === "ru") return ru_heading_reads_highlight(inputs)
	if (locale === "pl") return pl_heading_reads_highlight(inputs)
	return en_heading_reads_highlight(inputs)
});